module.exports = __webpack_public_path__ + "img/img_xinshou_4@2x.ad064305.png";